var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransferUtglWeb = function SvgTransferUtglWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Transfer_UTGL_Web_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3h8v6h-1.5V4.5H9V3ZM4.5 9v6.5H9V17H3V9h1.5Z",
    fill: "#4376B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8V0h8v8H0Zm10 12V10h10v10H10Z",
    fill: "#305992"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Transfer_UTGL_Web_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgTransferUtglWeb;